
import FormatSquare from "../../../assets/filled/FormatSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function FormatSquareIcon({ className, dataTestid = "FormatSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <FormatSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
